import { render } from "./Leaderboard.vue?vue&type=template&id=177c5f12&bindings={\"filter\":\"setup\",\"topChannels\":\"setup\",\"channelCountries\":\"setup\",\"prettyNumber\":\"setup\"}"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"
script.render = render

export default script